import { ROUTE_PATHS } from '../../routes/consts';

export const QODO_20_BANNER_STORAGE_KEY = 'qodo-2.0-banner-dismissed';
export const QODO_20_LINK =
  'https://docs.qodo.ai/qodo-documentation/code-review';

/**
 * Route prefixes where the Qodo 2.0 promo banner must not render. These are
 * admin / setup surfaces where a customer-facing promo over the workspace
 * configuration form (and the bootstrap modal it hosts) reads as unpolished.
 * A prefix suppresses the banner on its exact path and any sub-route.
 */
export const PROMO_BANNER_SUPPRESSED_ROUTE_PREFIXES = [
  `/${ROUTE_PATHS.TEAM_PROFILES}`,
  `/${ROUTE_PATHS.CONFIGURATION}`,
] as const;
